import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { users } from './users.reducer';
import { requests } from './request.reducer';
import { ldapServers } from './ldap.reducer';
import { settings } from './settings.reducer';
import { clock } from './clock.reducer';
import { report } from './report.reducer';
import { alert } from './alert.reducer';
import { delegation } from './delegation.reducer';
import { mail } from './mail.reducer';
import { notification } from './notification.reducer';
import { text } from './text.reducer';
import { userlock } from './userlock.reducer';

const rootReducer = combineReducers({
  authentication,
  users,
  requests,
  ldapServers,
  settings,
  clock,
  report,
  alert,
  mail,
  text,
  delegation,
  notification,
  userlock
});

export default rootReducer;
